{
  "common": {
    "terms": {
      "agreement": "I agree to the <terms>terms of service</terms>"
    }
  },
  "register_form": {
    "email_label": "Your business email address",
    "name_label": "Your full name",
    "company_name_label": "Your company name",
    "company_website_label": "Your website",
    "password_label": "Password",
    "role": {
      "default_label": "I'd like to trial SparkLayer on…",
      "team_member_label": "I'm activating my account on behalf of:",
      "placeholder": "Please select here",
      "merchant_default": "On my own brand's online store",
      "partner_default": "As an agency on a client's online store",
      "merchant_team_member": "A merchant who is using SparkLayer",
      "partner_team_member": "An agency that is using SparkLayer for a client"
    },
    "partner_terms_agreement": "I agree to the <terms>partner terms of service</terms>",
    "submit": "Continue →"
  },
  "enterprise_register_form": {
    "email_label": "Your business email address",
    "name_label": "Your full name",
    "company_name_label": "Your company name",
    "company_website_label": "Your website",
    "password_label": "Password",
    "submit": "Continue →"
  },
  "invite_register_form": {
    "email_label": "Email address",
    "name_label": "Full name",
    "password_label": "Password",
    "submit": "Create account",
    "success": "Please click the accept invitation link in the email."
  }
}
